import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  cursor: pointer;
`;

export const NotificationsContainer = styled.div`
  position: absolute;
  top: -2px;
  right: -2px;
  width: 18px;
  height: 18px;
  background: #ff0000;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NotificationsHeader = styled.div`
  background-color: #007bff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 62px;
  gap: 8px;

  position: absolute;
  top: 0;
  left: 0;
  right: 0;
`;

export const NotificationText = styled.span`
  font-family: 'Mangueira';
  font-size: 12px;
  color: #ffff;
  text-align: center;
  display: inline-flex;
  align-self: center;
  font-weight: bold;
`;

export const NotificationsIcon = styled.div`
  width: 0px;
  height: 0px;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 10px solid #007bff;
  position: absolute;
  right: 12px;
  top: -8px;

  @media (max-width: 600px) {
    display: none;
  }
`;

export const NotificationsBox = styled.div`
  z-index: 5;
  position: absolute;
  top: 40px;
  right: -6px;

  @media (max-width: 600px) {
    right: -60px;
  }
`;

export const NotificationsBoxContainer = styled.div`
  background: #fff;
  border-radius: 5px;
  box-shadow: rgb(216, 216, 216) 0px 0px 8px;
  display: -ms-flexbox;
  max-height: 432px;
  overflow: auto;

  @media (max-width: 600px) {
    max-width: 362px;
  }
`;

export const Title = styled.span`
  font-size: 16px;
  color: #fff;
  font-weight: bold;
  font-family: 'Mangueira Bold', sans-serif;
  display: inline-flex;
`;

export const QuantityContainer = styled.div`
  background: #fff;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const QuantityText = styled.span`
  color: #007bff;
  font-size: 14px;
  font-weight: 700;
  font-family: 'Mangueira Bold', sans-serif;
  display: inline-flex;
`;

export const NotificationsItems = styled.div`
  margin-top: 75px;
  padding: 0 18px;
  padding-bottom: 16px;
`;
